import { render } from "./dycgBorder.vue?vue&type=template&id=521771ec&scoped=true"
import script from "./dycgBorder.vue?vue&type=script&lang=js"
export * from "./dycgBorder.vue?vue&type=script&lang=js"

import "./dycgBorder.vue?vue&type=style&index=0&id=521771ec&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521771ec"]])

export default __exports__